import { Input } from "@/components/ui/input";

interface TeamIdFilterProps {
  value: string;
  onChange: (value: string) => void;
}

/** Free-text team id filter; the parent debounces before fetching. */
const TeamIdFilter = ({ value, onChange }: TeamIdFilterProps) => {
  return (
    <Input
      value={value}
      onChange={e => onChange(e.target.value)}
      aria-label="Team id"
      placeholder="Filter by team id (e.g. us-smu-dallas-tx|male)"
      className="max-w-md"
    />
  );
};

export default TeamIdFilter;
